/* eslint-disable indent */
import Swiper, { Navigation, Pagination, Autoplay, EffectFade } from 'swiper';

/*
 *  Main Carsouel
 */
$(function () {
	var swiper = new Swiper('#main-carousel', {
		modules: [Navigation, Pagination, Autoplay],
		autoHeight: false,
		loop: $('#main-carousel').find('.swiper-slide').length > 1,
		on: {
			init: function () {
				if ($('#main-carousel').find('.swiper-slide').length > 1) {
					$("#main-carousel").find('.swiper-slide[data-swiper-slide-index=0] .swiper-slide-bg .video').trigger('play');
				}
				else {
					$("#main-carousel").find('.swiper-slide-bg .video').trigger('play');
				}
			},
			slideChange: function () {
				if ($('#main-carousel').find('.swiper-slide[data-swiper-slide-index=' + this.realIndex + '] .swiper-slide-bg .video').length > 0) {
					$('#main-carousel').find('.swiper-slide[data-swiper-slide-index=' + this.realIndex + '] .swiper-slide-bg .video').trigger('play');
				} else {
					$('#main-carousel').find('.video').trigger('pause');
				}
			}
		},
		pagination: {
			el: $('#main-carousel').find('.swiper-pagination')[0],
			clickable: true,
		},
		autoplay: {
			delay: (location.hostname == "localhost" ? 5000000 : 5000),
		},
		speed: 400,
		breakpoints: {
			// when window width is >= Xpx
			992: {
				autoHeight: false
			}
		},
		navigation: {
			nextEl: '.swiper-next',
			prevEl: '.swiper-prev',
		},
	});

	sliderHeightHandle()
	$(window).resize(function () {
		sliderHeightHandle()
	});
})

function sliderHeightHandle() {

	var maxHeight = 0;

	$('#main-carousel').find('.swiper-slide').each(function () {
		if ($(this).height() > maxHeight) {
			maxHeight = $(this).height();
		}
	});
	$('#main-carousel').find('.swiper-slide').each(function () {
		$(this).height(maxHeight);
	});
	//if ($(window).width() > 991) {
	//}
}



/* 
 * Other sliders
 */
$(function () {
	//initializeSwiper(carouselSelector, loopEnabled, breakPoints)

	initializeSwiper('#evidenza-carousel', false, false);
	initializeSwiper('#gallery-carousel', true, false);
	initializeSwiper('#media-carousel', true, true);
	initializeSwiper('#loghi-carousel', true, true);
	//initializeSwiper('#expert-carousel', true, true);

	if ($('#loghi-carousel').find('.swiper-slide').length <= 1) {
		$('#loghi-carousel').find('.swiper-navigation').remove();
	}
});


//$(function () {
//	$(".carousel-esperti").each(function () {
//		//return;
//		var $this = $(this);
//		var url = $this.data("url")
//		$.ajax({
//			url: url
//		}).done(async function (response) {
//			initExperts($this, response)
//		});
//	})
//})
 
$(window).on('load', function () {
	$('.carousel-esperti').each(function () {
		const $el = $(this),
			url = $el.data('url');
		$.get(url)
			.done(html => {
				$el.animate({ opacity: 0 }, 300, () => {
					$el.html(html).css({ opacity: 1 });
					initializeSwiper('#expert-carousel', true, true);
				});
			})
			.fail(() => console.error('Errore loading esperti: modificata con un onload'));
	});
});


async function initExperts(el, res) {
	for (let i = 0; i < 3; i++) {
		console.log(`Waiting ${i} seconds...`);
		await sleep(1000);
	}
	el.animate({ opacity: 0 }, function () {
		$(this).html(res);
		el.css({opacity: 1});
		initializeSwiper('#expert-carousel', true, true);
	})
	
}

function sleep(ms) {
	return new Promise(resolve => setTimeout(resolve, ms));
}

/*
 * Generic swiper initializator
 */
function initializeSwiper(carouselSelector, loopEnabled, breakPoints) {
	var isLoghi = carouselSelector == '#loghi-carousel';
	var loghiHasMoreThanOne = $(carouselSelector).find('.swiper-slide').length > 1;
	var isExpert = carouselSelector == '#expert-carousel';
	var swiper = new Swiper(carouselSelector, {
		modules: [Navigation, Pagination, Autoplay, EffectFade],
		effect: breakPoints ? '' : 'fade',
		slidesPerView: breakPoints ? (isLoghi || isExpert ? 1 : 2) : 1,
		fadeEffect: {
			crossFade: true
		},
		on: {
			slideChange: function () {
				if ($(carouselSelector).find('.swiper-slide[data-swiper-slide-index=' + this.realIndex + '] video').length > 0) {
					$(carouselSelector).find('video').trigger('pause');
				}
			}
		},
		autoHeight: !isLoghi,
		loop: (loghiHasMoreThanOne && isLoghi ? loopEnabled : false),
		pagination: {
			el: $(carouselSelector).find('.swiper-pagination')[0],
			clickable: true,
		},
		autoplay: {
			delay: (location.hostname == "localhost" ? 5000000 : 5000),
		},
		speed: 400,
		navigation: {
			nextEl: $(carouselSelector).find('.swiper-button-next')[0],
			prevEl: $(carouselSelector).find('.swiper-button-prev')[0],
		},
		breakpoints: breakPoints ?
			(!isLoghi && !isExpert
				? {
					576: {
						slidesPerView: 1.4,
						spaceBetween: 15,
					},
					768: {
						slidesPerView: 2,
						spaceBetween: 30,
					},
					991: {
						slidesPerView: 2,
						spaceBetween: 40,
					},
				} :
				(isExpert
					? {
						200: {
							slidesPerView: 1,
							spaceBetween: 90,
						},
						550: {
							slidesPerView: 2,
							spaceBetween: 35,
						},
						991: {
							slidesPerView: 3,
							spaceBetween: 70,
							effect: '',
						},
						1200: {
							slidesPerView: 4,
							spaceBetween: 100,
							effect: '',
						},
					}
					:
					(!loghiHasMoreThanOne
						? {}
						: {
							200: {
								slidesPerView: 1,
								spaceBetween: 90,
							},
							450: {
								slidesPerView: 2,
								spaceBetween: 35,
							},
							600: {
								slidesPerView: 3,
								spaceBetween: 80,
							},
							991: {
								slidesPerView: 4,
								spaceBetween: 70,
								effect: '',
							},
							1200: {
								slidesPerView: 4,
								spaceBetween: 100,
								effect: '',
							},
						}
					)
				)) : {}
	});
}
